import { OptionSetQuery } from './model';

export const encodeOptionSetQuery = (query: OptionSetQuery) => ({
  page: query.page?.toString() || '1',
  perPage: query.perPage?.toString() || '20',
  search: query.search || '',
});
